module.exports = __webpack_public_path__ + "img/auction-line.559427f2.svg";